'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VideoCamera = require('./VideoCamera');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_VideoCamera).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/VideoCamera/index.js
// module id = 1314
// module chunks = 1